import { AES, enc } from "crypto-js";
import config from "../config";

export const encryptData = (plaintext) => {
    if (typeof plaintext !== "string") {
        plaintext = JSON.stringify(plaintext)
    }
    const secretKey = config.secretKey;

    const encryptedData = AES.encrypt(plaintext, secretKey).toString();
    // console.log('encryptedData', encryptedData)
    return encryptedData
}

export const decryptData = (encryptedData) => {
    const secretKey = config.secretKey;
    const decryptedBytes = AES.decrypt(encryptedData, secretKey);
    const decryptedData = decryptedBytes.toString(enc.Utf8);
    // console.log('decryptedData', decryptedData)
    return JSON.parse(decryptedData)
}

export const decryptText = (encryptedText) => {
    const decryptedBytes = AES.decrypt(encryptedText, config.privateKey);
    const decryptedText = decryptedBytes.toString(enc.Utf8);
    return decryptedText;
}

export const encryptText = (plaintext) => {
    const encryptedText = AES.encrypt(plaintext, config.privateKey).toString();
    return encryptedText;
}